import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  active: {
    height: '4px',
    backgroundColor: '#0768fd',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
  },
});

const ActiveBar = ({ visible }) => {
  const classes = useStyles();

  if (!visible) {
    return null;
  }

  return <div className={classes.active}>&nbsp;</div>;
};

export default ActiveBar;
